import svgUrl from "ni:svgr;ZS7ROraG48sX1efE0k1z3IpqeXDt1ocvUUOoBk4IrvI";
export default svgUrl;
import * as React from "react";
import { memo } from "react";
const ByExampleMIcon = props => <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} fill="none" viewBox="0 0 24 24" {...props}><path fill="var(--tbl--colors--icons--clean--primary)" d="M5.68341 12.1799L13.707 2.55162C14.041 2.15079 14.6886 2.46528 14.5802 2.97564L12.875 11H17.8634C18.2984 11 18.5259 11.5172 18.232 11.8379L9.26844 21.6162C8.92224 21.9939 8.29959 21.6685 8.41206 21.1686L10.25 13H6.06752C5.6436 13 5.41202 12.5056 5.68341 12.1799Z" /></svg>;
const Memo = memo(ByExampleMIcon);
export { Memo as ReactComponent };
if (import.meta.env.DEV) {
  Memo.displayName = "ByExampleMIcon";
}